var map = {
	"./big_rect1.png": 86217,
	"./bub001.png": 97672,
	"./circle1.png": 97643,
	"./circle2.png": 56105,
	"./circle2_bub361.png": 18358,
	"./circle3_bub361.png": 28952,
	"./circle4.png": 84512,
	"./circle5.png": 64044,
	"./circle6.png": 85915,
	"./circle_bub361.png": 73218,
	"./cub273.png": 34243,
	"./cub286.png": 29953,
	"./cub296.png": 93150,
	"./cub374.png": 54300,
	"./cub457.png": 88293,
	"./cub627.png": 36857,
	"./cub863.png": 88939,
	"./cub_0000.png": 52064,
	"./cub_0001.png": 73103,
	"./cub_0002.png": 37986,
	"./cub_0003.png": 93278,
	"./cub_0004.png": 49870,
	"./eightStar.png": 64057,
	"./eye.png": 94221,
	"./grd289A.png": 4921,
	"./grd289B.png": 5321,
	"./grd289Big.png": 3400,
	"./grd289C.png": 99699,
	"./grd289D.png": 1697,
	"./grd292C2_1.png": 89876,
	"./grd292C2_2.png": 99085,
	"./grd292Cross.png": 55622,
	"./grd292Right.png": 57143,
	"./grd292Up.png": 49242,
	"./grd329.png": 42058,
	"./grd341.png": 41713,
	"./grd341small.png": 57483,
	"./grd511_C2.png": 23728,
	"./grd511big.png": 23645,
	"./grd511small.png": 35925,
	"./grd_bonus.png": 12089,
	"./man009_1.png": 13973,
	"./man009_2.png": 74268,
	"./man009_3.png": 16535,
	"./mond.png": 43167,
	"./mond2.png": 82918,
	"./noStar.png": 3804,
	"./pfeil_mitte.png": 62058,
	"./pfeil_oben.png": 73966,
	"./pfeil_rechts.png": 84367,
	"./rect1.png": 18660,
	"./rect10.png": 98273,
	"./rect2.png": 18608,
	"./rect3.png": 98858,
	"./rect4.png": 10063,
	"./rect6.png": 21974,
	"./rect7.png": 53914,
	"./rect8.png": 49925,
	"./rect9.png": 78054,
	"./sam003.png": 54366,
	"./sam003_2.png": 43249,
	"./sam004.png": 79592,
	"./sam010.png": 45828,
	"./sam010_2.png": 79333,
	"./schiefes_rect1.png": 27831,
	"./singleStar.png": 96489,
	"./star1.png": 79559,
	"./star2.png": 95729,
	"./star_and_rect.png": 71883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90056;